/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>
///<reference path="ym-section-base.ts"/>

module Meevo.Plugins.YieldManagementProgram {

    export class YieldManagerStrategyEmployeesSection extends YmSectionBase {
        employeeAllSelected: boolean = false;
        backupEmployeeAllSelected: boolean;

        takeBackup(): void {
            super.takeBackup();
            this.backupEmployeeAllSelected = this.employeeAllSelected;
        }

        rollbackChanges(): void {
            super.rollbackChanges();
            setTimeout(() => {
                this.employeeAllSelected = this.backupEmployeeAllSelected;
            }, 0);
        }
    }
}
